import SubmitEvent = JQuery.SubmitEvent;
import ClickEvent = JQuery.ClickEvent;

jQuery(
	() => {
		console.debug( 'ready: Debug' )

		jQuery( '[data-action="generate-project"] form' ).on( 'submit', ( e:SubmitEvent ) => debug_generate_project( e ) )
		jQuery( '[data-action="generate-project"] .ui.dropdown' ).dropdown()

		jQuery( 'button[data-action="debug-update-roles"]' ).on( 'click', ( e: ClickEvent ) => debug_update_roles( e ) )
		jQuery( 'button[data-action="debug-delete-log"]' ).on( 'click', debug_delete_log )

        jQuery( 'button[data-action="send-completion-mails"]' ).on( 'click', debug_send_completion_mails )
	}
)

export function enable_debug() {
	gt_user_settings.enable_debug = '1'

    const debug_elements: HTMLElement[] = Array.from( document.querySelectorAll( '[data-debug]' ) )

	for ( const el of debug_elements ) {
		el.dataset.hidden = ''
	}

	for ( const el of Array.from( document.querySelectorAll( '.list-container table.ui' ) ) ) {
		el.classList.add( 'debug' )
	}
}

export function disable_debug() {
	gt_user_settings.enable_debug = '0'

    const debug_elements: HTMLElement[] = Array.from( document.querySelectorAll( '[data-debug]' ) )

	for ( const el of debug_elements ) {
		el.dataset.hidden = 'true'
	}

	for ( const el of Array.from( document.querySelectorAll( '.list-container table.ui' ) ) ) {
		el.classList.remove( 'debug' )
	}
}

export function debug_update_roles( e: ClickEvent ) {
	console.log( 'debug: update roles and caps' )

	// enable AJAX.
	e.preventDefault()

    const button: HTMLButtonElement|null = e.target as HTMLButtonElement

    if ( ! button ) {
        return
    }

	button.classList.add( 'disabled' )

	const { ajax_url, nonce } = gt_ajax_object

	const data = {
		action: 'debug_update_roles',
		nonce,
	}

	jQuery.ajax(
		{
			url: ajax_url,
			type: 'POST',
			dataType: 'json',
			data,
			cache: false
		}
	).done(
		( response ) => {
			console.log( response )

			button.classList.remove( 'disabled' )

			app.show_toast_ajax_response( 'Plugin: Rollen und Berechtigungen wurden aktualisiert' )
		}
	)
}

export function debug_generate_project( e: SubmitEvent ) {
	console.log( 'generate project' )

	// enable AJAX.
	e.preventDefault()

	const { ajax_url, nonce } = gt_ajax_object

	const form_data = jQuery( e.currentTarget ).serialize()

	const data = {
		action: 'debug_generate_project',
		form_data,
		nonce,
	}

	jQuery.ajax(
		{
			url: ajax_url,
			type: 'POST',
			dataType: 'json',
			data,
			cache: false
		}
	).done(
		( response ) => {
			console.log( response )

			if ( response.redirect ) {
				window.open( response.redirect, '_blank' )
				return
			}
		}
	)
}

export function debug_delete_log() {
	const list: HTMLElement|null = document.querySelector( '[data-list="debug-log"]' )

    if ( list ) {
        list.classList.remove( 'hidden' )
    }
}

export async function debug_send_completion_mails( e: ClickEvent ) {
    console.log( 'debug: send completion mails' )

    // enable AJAX.
    e.preventDefault();

    e.target.classList.add( 'disabled' )

    const data = await fetch_send_completion_mails()
    console.log( 'Mails gesendet?', data )
    e.target.classList.remove( 'disabled' )
}

export async function fetch_send_completion_mails() {
    const { ajax_url, post_id, nonce } = gt_ajax_object

    const data = {
        action: 'debug_send_completion_mails',
        post_id,
        nonce,
    }

    jQuery.ajax(
        {
            url: ajax_url,
            type: 'POST',
            dataType: 'json',
            data,
            cache: false
        }
    ).done(
        ( response ) => {
            console.log( response )
            return response
        }
    )
}
